// Register once per component, and replace the text when a module is hot reloaded.
export function registerStyles(name, css) {
  if (typeof document === "undefined") return;

  const id = `component-styles-${name}`;
  let style = document.getElementById(id);
  if (!style) {
    style = document.createElement("style");
    style.id = id;
    document.head.appendChild(style);
  }
  style.textContent = css;
}
